import { Component } from '@angular/core';
import { PasswordResetRequest, User_PasswordAdmin } from '../../../AllTableClasses';
import { AccountService } from '../../../Services/account.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { PopupNotificationService } from '../../../Services/popup-notification.service';

@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrl: './password-reset.component.scss'
})
export class PasswordResetComponent {

  public submitted: boolean = false;
  public request: PasswordResetRequest = new PasswordResetRequest();
  public GuidGeneratedForUser!: string;

  public newPassword!: string;
  public passwordConfirmation!: string;
  public passwordValidations = {
    minLength: false,
    uppercase: false,
    lowercase: false,
    number: false,
    specialChar: false,
  };

  constructor(
    private accountService: AccountService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private popupNotificationService: PopupNotificationService
  ) { }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe(params => {
      this.GuidGeneratedForUser = params['code'];
    }).unsubscribe();


    if (this.GuidGeneratedForUser == undefined || this.GuidGeneratedForUser == null || this.GuidGeneratedForUser == "") {
      this.RouteLogin();
    }
    else
    {
      this.ForgotPasswordRequestGet();
    }
  }

  public ForgotPasswordRequestGet() {
    this.accountService.ForgotPasswordRequestGet(this.GuidGeneratedForUser, (data) => {
      if (data.Success)
      {
        this.request = JSON.parse(data.Data);
      }
      else
      {
        this.popupNotificationService.showNotifcation('error', data.UserErrorMessage);
        this.RouteLogin();
      }
    }, (error) => { });
  }

  public RouteLogin() {
    this.router.navigate(['login']);
  }

  public validatePasswordStrength(password: string): void {
    this.passwordValidations.minLength = password.length >= 8;
    this.passwordValidations.uppercase = /[A-Z]/.test(password);
    this.passwordValidations.lowercase = /[a-z]/.test(password);
    this.passwordValidations.number = /\d/.test(password);
    this.passwordValidations.specialChar = /[@$!%*?&#]/.test(password);
  }

  public formSubmit(f: NgForm) {
    this.submitted = true;
    if (!f.invalid) {

      if (this.newPassword !== this.passwordConfirmation) {
        this.popupNotificationService.showNotifcation('error', 'Passwords do not match.');
        return;
      }
      if (this.passwordValidations.minLength == false || this.passwordValidations.uppercase == false || this.passwordValidations.lowercase == false || this.passwordValidations.number == false || this.passwordValidations.specialChar == false) {
        return;
      }
      this.request.Password = this.passwordConfirmation;

      this.accountService.UserPasswordReset(this.request, (data) => {
        if (data.Success)
        {
          this.popupNotificationService.showNotifcation('success', 'Password Successfully Updated ');
          this.RouteLogin();
        }
        else
        {
          this.popupNotificationService.showNotifcation('error', data.UserErrorMessage);
        }

      }, (error) => { });

    }

  }
}
